import toast from 'react-hot-toast';
import type { TranslationFunction } from '@/i18n';

let globalT: TranslationFunction | null = null;

// This function should be called from within a React component that has access to useTranslation
export function setToastTranslationFunction(t: TranslationFunction) {
  globalT = t;
}

// Helper function to translate or return original message
function translateMessage(key: string): string {
  if (globalT) {
    return globalT(key);
  }
  // Fallback to the key itself if translation function not available
  console.warn('Translation function not set for i18nToast. Using key as message.');
  return key;
}

export const i18nToast = {
  success: (key: string, options?: Parameters<typeof toast.success>[1]) => {
    return toast.success(translateMessage(key), options);
  },
  
  error: (key: string, options?: Parameters<typeof toast.error>[1]) => {
    return toast.error(translateMessage(key), options);
  },
  
  loading: (key: string, options?: Parameters<typeof toast.loading>[1]) => {
    return toast.loading(translateMessage(key), options);
  },
  
  custom: toast.custom,
  
  promise: <T,>(
    promise: Promise<T>,
    msgs: {
      loading: string;
      success: string;
      error: string;
    },
    options?: Parameters<typeof toast.promise>[2]
  ) => {
    return toast.promise(
      promise,
      {
        loading: translateMessage(msgs.loading),
        success: translateMessage(msgs.success),
        error: translateMessage(msgs.error),
      },
      options
    );
  },
  
  dismiss: toast.dismiss,
  remove: toast.remove,
};